export default __webpack_public_path__ + "static/pricing-e6479c39fd1beb5940a19ca368e32110.webp";